import React from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { clearUser } from '../store/userSlice';

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { name} = useSelector((state) => state.user);
  const displayName = name || 'User';
  const initial = displayName.trim().charAt(0).toUpperCase();

  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(clearUser());
    localStorage.clear();
    navigate('/');
  };

  return (
    <div>
      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        {/* Left navbar links */}
        <ul className="navbar-nav">
          <li className="nav-item">
            <Link className="nav-link" data-widget="pushmenu"  role="button"><i className="fas fa-bars" /></Link>
          </li>
        </ul>
        {/* Right navbar links */}
        <ul className="navbar-nav ml-auto">
          <li className="nav-item dropdown">
            <button
              className="nav-link p-1 user-dropdown-toggle"
              data-toggle="dropdown"
              type="button"
            >
              <div className="user-panel d-flex">
                <div className="image user_div">
                  {/* <img src="dist/img/user.png" class="img-circle elevation-2" alt="User Image"> */}
                  <span className="usercharacter">{initial || 'U'}</span>
                </div>
                <div className="info">
                  <span className="d-block f_black">{displayName} <i className="fa-solid fa-angle-down" /></span>
                  {/* <small className="d-block text-muted">{email || role}</small> */}
                </div>
              </div>
            </button>
            <div className="dropdown-menu dropdown-menu-right">
              <Link to="/profile" className="dropdown-item mb-2">
                <i className="fa-solid fa-user mr-2" /> Profile
              </Link>
              <Link to="/" className="dropdown-item" onClick={handleLogout}>
                <i className="fa-solid fa-arrow-right-from-bracket mr-2" /> Logout
              </Link>
            </div>
          </li>
        </ul>
      </nav>
    </div>
  )
}

export default Header